import React from 'react';
import { FileCheck, Trophy, Radio } from 'lucide-react';
import { SidebarView } from './SessionSidebar';
import { BidExtractTab } from './BidExtractTab';
import { WinThemesTab } from './WinThemesTab';
import { TabletopRunTab } from './TabletopRunTab';

export interface SessionModuleTabProps {
  sessionId: string;
  projectId?: string;
}

export interface SessionModuleTab {
  id: SidebarView;
  label: string;
  icon: React.ElementType;
  permission: string;
  // Project switch the module's backend routes require (403 when off).
  projectFlag: 'reachEnabled' | 'bidEnabled' | 'tabletopEnabled';
  Component: React.ComponentType<SessionModuleTabProps>;
}

// Session-linked modules (REACH, Bid Response, etc) register their live-session
// extraction tab here instead of adding a switch-case + threaded boolean prop
// per module. Append future modules to this array only.
export const sessionModuleTabs: SessionModuleTab[] = [
  { id: 'bid-extract', label: 'Extract to Bid', icon: FileCheck, permission: 'Modules::UseBid', projectFlag: 'bidEnabled', Component: BidExtractTab },
  { id: 'bid-win-themes', label: 'Win Themes', icon: Trophy, permission: 'Modules::UseBid', projectFlag: 'bidEnabled', Component: WinThemesTab },
  { id: 'tabletop-run', label: 'Tabletop Run', icon: Radio, permission: 'Modules::UseTabletop', projectFlag: 'tabletopEnabled', Component: TabletopRunTab },
];
